<template>
  <div id="app">
    <Headers v-if="$route.name != 'login'" />
    <div class="main-container">
      <RouterView :key="$route.fullPath" />
    </div>
    <Footers />
  </div>
</template>
<script>
import Headers from '@/views/Headers.vue';
import Footers from '@/views/Footers.vue';
import Vue from 'vue';
import Toasted from 'vue-toasted';
import VueTables from 'vue-tables-2';

Vue.use(Toasted);
Vue.use(VueTables.ClientTable);
export default {
  name: 'App',
  components: {
    Headers,
    Footers,
  },
};
</script>

<style>
@import "../src/assets/css/vue-table-2.css";

.main-container {
  margin: 2rem auto 4rem;
  max-width: 1160px;
  padding: 0;
}

.form-fields {
  padding: 5px;
}

ul {
  list-style: none;
}

input[type="text"],
input[type="password"],
input[type="number"],
input[type="file"] {
  width: 20%;
  padding: 12px 20px;
  margin: 8px;
  box-sizing: border-box;
  display: block;
  border: 1px solid #ccc;
}

.multiselect__input {
  border: 0 !important;
}

textarea {
  width: 50%;
  height: 150px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  resize: none;
}

select {
  width: 20%;
  border-radius: 4px;
  height: 40px;
  border: 1px solid #ccc;
  display: block;
  margin: 0.5rem 8px 1rem 0;
}

.popup button {
  background-color: #4caf50;
  border: none;
  color: white;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}

.btn-container button {
  margin-left: 5px;
}

.popup button + button {
  background-color: #f44336;
}

.glyphicon-eye-open {
  color: blue;
}

.glyphicon-edit {
  color: #3ca23c;
}

.glyphicon-trash {
  color: #f44336;
}

.glyphicon-download-alt {
  color: orange;
}

.button_create {
  cursor: pointer;
  background: #3ca23c;
  text-decoration: none;
  margin: 4px;
  padding: 10px;
  text-align: center;
  color: white;
  font-weight: bold;
  display: inline-block;
}

.main_heading {
  background-color: #ccc;
  display: inline-block;
  width: 100%;
  margin-bottom: 1rem;
}

.main_heading h3 {
  display: inline-block;
  margin: 5px 0 0 15px;
  line-height: 44px;
}

.main_heading .button_create {
  margin: 0.5em;
  float: right;
}

.popup {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

.popup-data {
  width: 20%;
  margin: auto;
  height: auto;
  background-color: #fff;
  padding: 25px;
  text-align: center;
}

.btn-container {
  margin-top: 10% !important;
}
</style>
